/**
 * 新闻资讯管理后台api
 * 新闻资讯管理后台相关接口
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../news/model/CreatedVo';
import NewsAdminDetailVo from '../../news/model/NewsAdminDetailVo';
import NewsCreateForm from '../../news/model/NewsCreateForm';
import NewsPreviewUrlVo from '../../news/model/NewsPreviewUrlVo';
import NewsUpdateForm from '../../news/model/NewsUpdateForm';
import PagingNewsAdminVo from '../../news/model/PagingNewsAdminVo';
import UpdatedVo from '../../news/model/UpdatedVo';
  /**
   * NewsManage service.
   * @module news/api/NewsManageApi
   * @version 0.1.0
   */

  /**
   * Constructs a new NewsManageApi. 
   * @alias module:news/api/NewsManageApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 创建新闻
     * @param {module:news/model/NewsCreateForm} newsCreateForm 新闻创建表单
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/CreatedVo}
     */
this.createNews = function(newsCreateForm) {
      var postBody = newsCreateForm;

      // verify the required parameter 'newsCreateForm' is set
      if (newsCreateForm == undefined || newsCreateForm == null) {
        throw "Missing the required parameter 'newsCreateForm' when calling createNews";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/company/news/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 生成新闻预览地址（管理后台）
     * 生成用于审核的新闻预览参数（无需登录）。 - 后端仅返回预览参数（id/m/s），由前端自行拼装预览地址 - 预览参数长期有效，可用于发送给上级审核 - 参数包含防猜测签名，不能通过简单拼接构造 - 参数中包含新闻修改时间信息（m），用于失效校验 
     * @param {Integer} id 新闻ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/NewsPreviewUrlVo}
     */
this.createNewsPreviewUrl = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling createNewsPreviewUrl";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = NewsPreviewUrlVo;
      return this.apiClient.callApi(
        '/api/company/news/{id}/preview_url', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除新闻（软删除）
     * @param {Integer} id 新闻ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/UpdatedVo}
     */
this.deleteNews = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteNews";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/company/news/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取新闻详情（管理后台）
     * @param {Integer} id 新闻ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/NewsAdminDetailVo}
     */
this.getNewsDetailForAdmin = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getNewsDetailForAdmin";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = NewsAdminDetailVo;
      return this.apiClient.callApi(
        '/api/company/news/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据预览地址查看新闻（匿名访问）
     * 通过预览地址匿名访问新闻内容（无需登录）。 - m: 新闻生成预览时的修改时间毫秒值 - s: 预览签名 - 若新闻在生成预览后被重新编辑，则老预览地址会失效 
     * @param {Integer} id 新闻ID
     * @param {Integer} m 新闻修改时间毫秒值（用于校验是否被重新编辑）
     * @param {String} s 预览签名（防篡改、防猜测）
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/NewsAdminDetailVo}
     */
this.getNewsPreviewByLink = function(id, m, s) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getNewsPreviewByLink";
      }

      // verify the required parameter 'm' is set
      if (m == undefined || m == null) {
        throw "Missing the required parameter 'm' when calling getNewsPreviewByLink";
      }

      // verify the required parameter 's' is set
      if (s == undefined || s == null) {
        throw "Missing the required parameter 's' when calling getNewsPreviewByLink";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'm': m,
        's': s
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = NewsAdminDetailVo;
      return this.apiClient.callApi(
        '/api/company/news/preview/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页获取新闻列表（管理后台）
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.categoryId 新闻分类：1-通知，2-动态，3-政策，不传则查询所有分类
     * @param {Integer} opts.status 新闻状态：0-草稿，1-已发布，不传则查询所有状态
     * @param {String} opts.title 新闻标题（模糊查询）
     * @param {Integer} opts.page 页码，从1开始，默认为1 (default to 1)
     * @param {Integer} opts.pageSize 每页大小，默认为10 (default to 10)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/PagingNewsAdminVo}
     */
this.listNewsForAdmin = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'categoryId': opts['categoryId'],
        'status': opts['status'],
        'title': opts['title'],
        'page': opts['page'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingNewsAdminVo;
      return this.apiClient.callApi(
        '/api/company/news/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 发布新闻
     * 发布新闻并设置发布时间。 注意：发布操作不修改 fm_news_article.gmt_modified。 
     * @param {Integer} id 新闻ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/UpdatedVo}
     */
this.publishNews = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling publishNews";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/company/news/{id}/publish', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 更新新闻
     * @param {Integer} id 新闻ID
     * @param {module:news/model/NewsUpdateForm} newsUpdateForm 新闻更新表单
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/UpdatedVo}
     */
this.updateNews = function(id, newsUpdateForm) {
      var postBody = newsUpdateForm;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateNews";
      }

      // verify the required parameter 'newsUpdateForm' is set
      if (newsUpdateForm == undefined || newsUpdateForm == null) {
        throw "Missing the required parameter 'newsUpdateForm' when calling updateNews";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/company/news/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 撤回新闻
     * @param {Integer} id 新闻ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/UpdatedVo}
     */
this.withdrawNews = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling withdrawNews";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/company/news/{id}/withdraw', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
